/** UI labels / value display in Lao for training-standard module */

import { CHECKLIST_DUE_SOON_HOURS } from "../../domain/checklist-schedule";

export function labelChecklistAlertStatus(status: string): string {
  switch (status) {
    case "overdue":
      return "ເກີນກຳນົດສົ່ງ";
    case "due_soon":
      return `ໃກ້ຄົບກຳນົດ (≤ ${CHECKLIST_DUE_SOON_HOURS} ຊມ.)`;
    case "none":
    default:
      return "";
  }
}

export function labelChecklistExecutionStatus(status: string): string {
  switch (status) {
    case "pending":
      return "ລໍຖ້າ";
    case "in_progress":
      return "ກຳລັງດຳເນີນງານ";
    case "completed":
      return "ສຳເລັດແລ້ວ";
    case "cancelled":
      return "ຍົກເລີກ";
    default:
      return status;
  }
}

export function labelServiceStage(stage: string): string {
  switch (stage) {
    case "before":
      return "ກ່ອນບໍລິການ";
    case "during":
      return "ລະຫວ່າງບໍລິການ";
    case "after":
      return "ຫຼັງບໍລິການ";
    case "all":
      return "ທຸກຊ່ວງ";
    default:
      return stage;
  }
}

export function labelKpiMeasurementPeriod(period: string): string {
  switch (period) {
    case "monthly":
      return "ລາຍເດືອນ";
    case "quarterly":
      return "ລາຍໄຕມາດ";
    case "yearly":
      return "ລາຍປີ";
    default:
      return period;
  }
}

export function labelKpiResultStatus(status: string | null): string {
  if (!status) return "ລໍຖ້າ";
  switch (status) {
    case "pass":
      return "ຜ່ານ";
    case "fail":
      return "ບໍ່ຜ່ານ";
    case "pending":
      return "ລໍຖ້າ";
    default:
      return status;
  }
}

export function labelStandardItemType(itemType: "do" | "dont"): string {
  return itemType === "do" ? "ຕ້ອງເຮັດ" : "ຫ້າມເຮັດ";
}

const SCHEMA_DOW_LAO: Record<number, string> = {
  1: "ວັນຈັນ",
  2: "ວັນອັງຄານ",
  3: "ວັນພຸດ",
  4: "ວັນພະຫັດ",
  5: "ວັນສຸກ",
  6: "ວັນເສົາ",
  7: "ວັນອາທິດ",
};

export function labelChecklistSchemaDayOfWeek(dow: number): string {
  return SCHEMA_DOW_LAO[dow] ?? `ວັນ (${dow})`;
}

/** Human-readable checklist cadence for employees (Lao). */
export function formatChecklistScheduleSummary(props: {
  scheduleType: "daily" | "opening" | "closing" | "scheduled";
  scheduleFrequency: "daily" | "weekly" | "monthly" | null;
  scheduleDayOfWeek: number | null;
  scheduleDayOfMonth: number | null;
}): string {
  const {
    scheduleType,
    scheduleFrequency,
    scheduleDayOfWeek,
    scheduleDayOfMonth,
  } = props;
  if (scheduleType === "daily") return "ທຸກວັນ";
  if (scheduleType === "opening") return "ຊ່ວງເປີດຮ້ານ / ກະເປີດ";
  if (scheduleType === "closing") return "ຊ່ວງປິດຮ້ານ / ກະປິດ";

  const freq = scheduleFrequency ?? "daily";
  if (freq === "daily") return "ຕາມກຳນົດ · ທຸກວັນ";
  if (freq === "weekly") {
    if (
      scheduleDayOfWeek != null &&
      scheduleDayOfWeek >= 1 &&
      scheduleDayOfWeek <= 7
    ) {
      return `ຕາມກຳນົດ · ທຸກອາທິດ · ${labelChecklistSchemaDayOfWeek(scheduleDayOfWeek)}`;
    }
    return "ຕາມກຳນົດ · ທຸກອາທິດ";
  }
  if (freq === "monthly") {
    if (
      scheduleDayOfMonth != null &&
      scheduleDayOfMonth >= 1 &&
      scheduleDayOfMonth <= 31
    ) {
      return `ຕາມກຳນົດ · ທຸກເດືອນ · ວັນທີ ${scheduleDayOfMonth}`;
    }
    return "ຕາມກຳນົດ · ທຸກເດືອນ";
  }
  return "ຕາມກຳນົດ";
}
